import { Box } from '@skin-seoul/design-system';
import { CountryChangeButton } from '@skin-seoul/shared-components';
import type { Country } from '@skin-seoul/service';
import { useRegionCurrency } from '@skin-seoul/service';
import { useEffect } from 'react';

interface CountryChangeShortcodeProps {
  initialCountry?: Country;
}

const CountryChangeShortcode = ({ initialCountry }: CountryChangeShortcodeProps) => {
  const { country, setCountry } = useRegionCurrency();

  // Set initial country if provided via props
  useEffect(() => {
    if (initialCountry && initialCountry !== country) {
      setCountry(initialCountry);
    }
  }, [initialCountry, country, setCountry]);

  const handleCountryChange = (newCountry: Country) => {
    setCountry(newCountry);
  };

  return (
    <Box width="100%" display="flex" justifyContent="center" alignItems="center" boxSizing="border-box" padding={2}>
      <CountryChangeButton country={country} onCountryChange={handleCountryChange} />
    </Box>
  );
};

export default CountryChangeShortcode;
